import { useParams } from 'react-router'
import { useSelector } from 'react-redux'

import { DocumentMeta } from '../components/DocumentMeta'
import { LegalGuaranteeNotice } from '../components/LegalGuaranteeNotice/LegalGuaranteeNotice'
import { PageOrCategoryContext } from './Category'
import { loadLegalPage } from '../store/actions'
import { useTranslate } from '../utils/translate'
import CookieConsent from '../components/CookieConsent'
import Theme from '../components/Theme'

export default function LegalPage() {
  const t = useTranslate('shop')
  const params = useParams()

  const shop = useSelector<State, ImmutableMap>((state) => state.get('shop'))
  const viewError = useSelector<State, ImmutableMap>((state) => state.getIn(['view', 'error']))
  const page = useSelector<State, ImmutableMap>((state) => state.get('legalPagesContents').get(params.legalPageSlug))
  const isEditor = useSelector<State, boolean>((state) => Boolean(state.getIn(['view', 'editorMode'])))

  if (viewError || !page) {
    return (
      <>
        <DocumentMeta />
        <Theme withLayout error={viewError} currentView="legal" />
      </>
    )
  }

  const cookieNoticeSettings: ImmutableMap = shop.getIn(['userSettings', 'cookieNotice'])
  const showCookieConsentPreview = Boolean(
    cookieNoticeSettings && cookieNoticeSettings.get('active') && page.get('slug') === 'cookiepolicy',
  )
  const showLegalGuaranteeNotice = page.get('slug') === 'legal-guarantee-notice'

  const isBeyondShop = Boolean(shop.get('beyond'))
  const pageTitle = isBeyondShop ? t(page.get('title')) : page.get('title')

  return (
    <PageOrCategoryContext.Provider value={page}>
      <DocumentMeta
        title={`${pageTitle} - ${shop.get('title')}`}
        meta={[{ name: 'robots', content: 'noindex, follow' }]}
      />
      <Theme withLayout currentView="legal">
        {(renderView, props) => (
          <>
            {renderView('Legal', {
              ...props,
              page: page.toJS(),
            })}
            {showCookieConsentPreview && (
              <section className="section">
                <CookieConsent inline isEditor={isEditor} />
              </section>
            )}
            {showLegalGuaranteeNotice && (
              <section className="section">
                <LegalGuaranteeNotice />
              </section>
            )}
          </>
        )}
      </Theme>
    </PageOrCategoryContext.Provider>
  )
}

LegalPage.storeUpdate = (props: RouteComponentProps<'legalPageSlug'>, state: State) => {
  const isForwardNavigation = props.location.action === 'PUSH'
  const updates: ApiAction<any>[] = []
  if (isForwardNavigation || !state.getIn(['legalPagesContents', props.params.legalPageSlug])) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    updates.push(loadLegalPage(props.params.legalPageSlug!))
  }
  return updates
}

LegalPage.contentCreationDisabled = () => true
